export default __webpack_public_path__ + "static/media/OptometryFill.3820343d.svg";